import axios from "axios"
import firebase from "firebase"

import { AppEnv } from "../app/app.env"

/**
 * Classe responsavel pela manipulação dos eventos
 */
export class EventService {

  static getEvents(option): any {

    const user = firebase.auth().currentUser
    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/mobile-${option}-events`

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
      .then((response) => {

        if (option == "pending") {

          response.data.forEach((event) => EventService.setEventStatus(event))

        } else if (option == "next") {

          response.data.forEach((month) => {

            month.events.forEach((event) => EventService.setEventStatus(event))
          })
        }

        return response.data
      })
  }

  static getUsersNextEvents(data: any): any {

    const user = firebase.auth().currentUser
    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/mobile-users-next-events/${data.event._id}`

    return axios.post(scheduleApiUrl, { email: user.email, userIds: data.userIds }, { headers: AppEnv.scheduleApi.headers })
      .then((response) => {

        let months = response.data

        months.forEach((month) => {

          month.events.forEach((event) => EventService.setEventStatus(event))
        })

        return months
      })
  }

  static getEventDetail(eventId) {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/mobile-event-detail/${eventId}`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
      .then((response) => EventService.setEventStatus(response.data))
  }

  static getEventsDetail(eventIds) {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/mobile-events-detail`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { eventIds, email: user.email }, { headers: AppEnv.scheduleApi.headers })
      .then((response) => {

        let months = response.data

        months.forEach((month) => {

          month.events.forEach((event) => EventService.setEventStatus(event))
        })

        return months
      })
  }

  static setEventStatus(event, status?) {

    event.statusData = {}

    if (status)
      event.status = status

    if (event.status == "confirmed") {

      event.statusData = { icon: "checkmark-circle", color: "success", description: "Confirmado" }

    } else if (event.status == "waiting_confirmation") {

      event.statusData = { icon: "time", color: "warning", description: "Aguardando confirmação" }

    } else if (event.status == "exchange_requested") {

      event.statusData = { icon: "repeat", color: "pink", description: "Troca solicitada" }

    } else if (event.status == "released") {

      event.statusData = { icon: "redo", color: "purple", description: "Liberado" }

    } else if (event.status == "missed") {

      event.statusData = { icon: "close-circle", color: "danger", description: "Falta" }
    }

    event.isLoadingPicture = true

    return event
  }

  static confirmEvent(event): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/confirm-event/${event._id}`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
      .then(() => {

        EventService.setEventStatus(event, "confirmed")

        return event
      })
  }

  static releaseEvent(event, comments, suggestedUsers): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/release-event/${event._id}`

    let userIds = []

    suggestedUsers.forEach((user) => userIds.push(user._id))

    return axios.post(scheduleApiUrl, { comments, suggestedUsers: userIds }, { headers: AppEnv.scheduleApi.headers })
      .then(() => {

        EventService.setEventStatus(event, "released")

        return event
      })
  }

  static exchangeEvent(event, comments, suggestedEvents): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/exchange-event/${event._id}`

    let eventIds = []

    suggestedEvents.forEach((event) => eventIds.push(event._id))

    return axios.post(scheduleApiUrl, { comments, suggestedEvents: eventIds }, { headers: AppEnv.scheduleApi.headers })
      .then(() => {

        EventService.setEventStatus(event, "exchange_requested")

        return event
      })
  }

  static cancelReleaseOrExchange(event): any {

    const option = event.status == "released" ? "release" : "exchange"
    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/cancel-event-${option}/${event._id}`

    return axios.post(scheduleApiUrl, null, { headers: AppEnv.scheduleApi.headers })
      .then(() => {

        event.releasedBy = null
        event.releaseComments = ""
        event.suggestedUsers = []
        event.exchangeRequestedBy = null
        event.exchangeRequestComments = ""
        event.suggestedEvents = []

        EventService.setEventStatus(event, "waiting_confirmation")

        return event
      })
  }

  static acceptEventRelease(event): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/accept-event-release/${event._id}`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
  }

  static rejectEventRelease(event): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/reject-event-release/${event._id}`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
  }

  static acceptEventExchange(data: any): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/accept-event-exchange/${data.event._id}`

    return axios.post(scheduleApiUrl, { acceptedEventId: data.acceptedEvent._id }, { headers: AppEnv.scheduleApi.headers })
  }

  static rejectEventExchange(event): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/reject-event-exchange/${event._id}`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
  }

  static rejectEvent(event): any {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/reject-event/${event._id}`
    const user = firebase.auth().currentUser

    return axios.post(scheduleApiUrl, { email: user.email }, { headers: AppEnv.scheduleApi.headers })
  }

  static validEventExchange(data: any) {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/valid-event-exchange/${data.event._id}`

    return axios.post(scheduleApiUrl, { acceptedEventId: data.acceptedEvent._id }, { headers: AppEnv.scheduleApi.headers })
  }

  static isLoggedUserEvent(event) {

    if (!event.user)
      return false

    const loggedUser = firebase.auth().currentUser

    return EventService.isUserEvent(loggedUser, event)
  }

  static isUserEvent(user, event) {

    if (!event || !event.user)
      return false

    return (event.user.email == user.email || event.user.uid == user.uid || event.user._id == user._id)
  }
}



// WEBPACK FOOTER //
// ./src/services/event.ts